/** Returns a UTC date string for the given `dateObject`. If `time` is false, then the time portion of the string is
 * removed.
 *
 * @param dateObject - The `DateObject` to convert to a date string
 * @param [time=true] - Optional flag used to remove the time portion of the date string if false
 * @returns - The UTC date string
 */
export default function toDateString(dateObject) {
  var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var year = dateObject.year,
      month = dateObject.month,
      day = dateObject.day,
      _dateObject$hour = dateObject.hour,
      hour = _dateObject$hour === void 0 ? 0 : _dateObject$hour,
      _dateObject$minute = dateObject.minute,
      minute = _dateObject$minute === void 0 ? 0 : _dateObject$minute,
      _dateObject$second = dateObject.second,
      second = _dateObject$second === void 0 ? 0 : _dateObject$second;
  var utcTime = Date.UTC(year, month - 1, day, hour, minute, second);
  var datetime = new Date(utcTime).toJSON();
  return time ? datetime : datetime.slice(0, 10);
}